export default __webpack_public_path__ + "locales/vi/ArchiveDialog.json?hash=93811013b1e773b2100264630594a9dc";